import Vue from 'vue'
import { router } from '@/router/router'
import { store } from '@/store/store'
import App from '@/App.vue'

import VueI18n from 'vue-i18n'
Vue.use(VueI18n)
import { messages } from '@/locales/locales'

// Create VueI18n instance with options
const i18n = new VueI18n({
  locale: 'fr',
  fallbackLocale: 'en',
  messages, 
})

new Vue({
  el: '#app',
  i18n,
  store,
  router,
  render: h => h(App),
})



// WEBPACK FOOTER //
// ./src/main.js